<template>
    <div class="vertical-flow select-modal">
        <div class="columns">
            <div class="column is-3 modal-icons" v-show="hasOcorrenciaSelecionada">
                <svg class="svg-icons" @click="openModal('geral')">
                    <use :xlink:href="require('@/assets/img/icons/card-reader.svg') + '#layer'" />
                </svg>
                <svg
                    class="svg-icons"
                    @click="openModal('produtos-ocorrencia')"
                    v-show="ocorrenciaHasProdutos"
                >
                    <use :xlink:href="require('@/assets/img/icons/cash-register.svg') + '#layer'" />
                </svg>
                <svg
                    class="svg-icons"
                    @click="openModal('anexos-ocorrencia')"
                    v-show="ocorrenciaHasAnexos"
                >
                    <use :xlink:href="require('@/assets/img/icons/no-image.svg') + '#layer'" />
                </svg>
            </div>
            <div class="column is-4 is-offset-5">
                <button
                    v-if="situacao == 4 && permissao.create"
                    class="save-btn botao-acao"
                    type="button"
                    @click="showModal = !showModal"
                >
                    {{ $t('nova-recomendacao') }}
                </button>
            </div>
        </div>

        <div class="registry-wrapper">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />

            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="visitarecomendacao"
                class="data-table"
                @sort="sortTable"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{ 'excluir-field': f.key == 'excluir' }"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'descricao'">
                        {{ isNull(props.row[f.key]) ? '---' : cutString(props.row[f.key], 100) }}
                    </div>
                    <div v-else-if="f.key == 'tiporecomendacao'">
                        <a @click="showModalEdit(props.row)">
                            {{ props.row[f.key].descricao }}
                        </a>
                    </div>
                    <div v-else-if="f.key == 'datahora_visita'">
                        {{ props.row[f.key] | moment('L LT') }}
                    </div>
                    <div v-else-if="f.key == 'excluir'">
                        <span v-if="permissao.delete">
                            <b-button
                                class="action-button"
                                type="is-danger"
                                icon-right="delete"
                                @click="promptDelete(props.row)"
                                v-tippy
                                :title="$t('excluir')"
                            />
                        </span>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
        <!-- MODAL -->
        <b-modal :active.sync="showModal" @fecharModal="fecharModal">
            <div class="bg">
                <RecomendacaoModal
                    :uuid="visitarecomendacaoUUID"
                    :cantEdit="cantEdit"
                    @fecharModal="fecharModal"
                    @save="fecharModal(), carregarDados()"
                    :situacao="situacao"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import AgroVisitaItemRecomendacaoService from '@/services/agro/agrovisita/AgroVisitaItemRecomendacaoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import RecomendacaoModal from '@/components/agro/agro-visita-item/modal/RecomendacaoModal';

export default {
    components: {
        ContainerLoader,
        RecomendacaoModal,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        cantEdit: {
            type: Boolean,
            default: false,
        },
        situacao: {
            type: Number,
            default: 0,
        },
        hasOcorrenciaSelecionada: {
            type: Boolean,
            default: false,
        },
        ocorrenciaHasProdutos: {
            type: Boolean,
            default: false,
        },
        ocorrenciaHasAnexos: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AgroVisitaItemRecomendacaoService(this.$http, this.$router),
            isLoading: false,
            permissao: false,
            isEmpty: false,
            column: 'datahora',
            order: 'asc',

            visitarecomendacaoUUID: null,
            visitarecomendacao: [],
            fields: [
                { key: 'codigo', width: null, sortable: false, sortFn: null },
                { key: 'tiporecomendacao', width: null, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: false, sortFn: null },
                { key: 'datahora_visita', width: null, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            // Modal
            showModal: false,
            delete: null,
        };
    },
    watch: {
        showModal(val) {
            if (!val) this.visitarecomendacaoUUID = null;
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('agro', 'agro-visita', 'agro-visita');
        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'recomendacao' },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-visita-item-recomendacao-' + numberId;
        },
        fecharModal() {
            this.showModal = false;
        },
        showModalEdit(row) {
            this.visitarecomendacaoUUID = row.codigo;
            this.showModal = true;
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            let params = [this.$route.params.id];

            this.service
                .findAll(this.column, this.order, currentPage - 1, this.pagination.perPage, params)
                .then(this.mapItems)
                .then((value) => {
                    this.visitarecomendacao = Object.assign(value);
                    this.isEmpty = this.visitarecomendacao.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados!');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    codigo: m.uuid,
                    uuid: m.uuid,
                    descricao: m.observacao,
                    tiporecomendacao: m.tiporecomendacao,
                    datahora_visita: m.datahora,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        promptDelete(row) {
            this.delete = row;
            let message = this.$t('msg-confirmacao-exclusao-n', { 
                n: this.$t('codigo') + ' ' + row.codigo + ' - ' + row.tiporecomendacao.descricao 
            });
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.deleteRegistro(),
                onCancel: (_) => this.removePrompt(),
            });
        },
        openModal(buttonClicked) {
            let info = {
                buttonClicked: buttonClicked,
            };
            this.$emit('open-modal-info-ocorrencia', info);
        },
        removePrompt() {
            this.delete = null;
        },
        deleteRegistro() {
            this.isLoading = true;
            this.service
                .delete(this.delete.uuid)
                .then((value) => {
                    if (value.message == null) {
                        let msg = this.$t('msg-delete-sucesso-n', { n: this.$t('recomendacao') });
                        this.$root.showMessage('success', msg, true, false);

                        this.carregarDados(this.pagination.currentPage);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.botao-acao {
    width: 100%;
    height: 40px;
}

.modal-icons {
    .svg-icons {
        margin-right: 5px;
        width: 35px;
        height: 35px;
        fill: $semi-title-color;
        cursor: pointer;
    }
}
</style>
